<template>
    <div class="mw-process-viewer">
      <div class="mw-process-chart">
        <MwProcessChartEditor :value="processDataGraph" :color="color" :editable="false" @requestTitle="handleRequestTitle" />
      </div>
      <div class="mw-process-chart-switch" v-if="processCount>1">
        <div class="_toolbar">
          <el-button class="el-button el-button--primary" @click="processSwitchClick()"><i class="fa fa-eye"></i><span v-text="showProcessList?'隐藏流程列表':'查看流程列表'"></span></el-button>
        </div>
        <div class="_tab process-list" v-if="showProcessList">
          <el-card class="box-card">
            <template v-for="n in processList">
              <li class="_item" :class="{'active':(curFlowId==n.id)}" @click="processClick(n,$event)">
                <span class="label label-info" v-text="!n.isSub?'主':''"></span>
                <el-badge :is-dot="n.id==originalFlowId"><span v-html="n.name"></span></el-badge>
              </li>
            </template>
          </el-card>
        </div>
      </div>
    </div>
</template>


<script>
  export default {
    name:"flow-chart-viewer",
    props: {
      params: Object,
      parentObj:Object
    },
    data() {
      return {
        processDataGraph: undefined,
        color: undefined,
        processList: [],
        curFlowId: undefined,
        originalFlowId: "",
        processCount: 0,
        showProcessList: false,
        isInit : false,
        flowProcess: []
      };
    },
    mounted() {
      /*setTimeout(()=>{
          this.show();
        },200)*/
      this.processChart(this.params);
      this.originalFlowId = this.params.processDefinitionId;
    },
    methods: {
      processChart({ applicationId, processDefinitionId, batchId }) {
        let me = this;
        this.mwApi.process
          .getFlowChartData({
            batchId: batchId,
            appId: applicationId,
            id: processDefinitionId
          })
          .then(async data => {
            if (!data.result || !data.result.flows) {
              // me.mwRef("dialog").hide();
              me.mwMsg("info", $lang("获取流程图数据失败"));
              return;
            } else {
              let flowData = data.result.flows;
              if (flowData.graph && flowData.graph.activity) {
                flowData.graph.activity.forEach(act => {
                  if(window.$currentBrowserLanguage==='en'){
                    act._name=act.name;
                    act.name=$lang(act.name);
                  }
                });
              }
              me.processDataGraph = flowData.graph;
              me.title = $lang("流程图")+"-" + $lang(flowData.name) + "(" + flowData.version + ".0)";
              if(me.parentObj){
                me.parentObj.title = me.title;
              }
              let colors = [];
              let activityStatus = flowData.activityStatus;
              let startId = "";
              let flag = false;
              for (let a in activityStatus) {
                if (activityStatus[a] == "T") {
                  colors.push({ id: a, color: "#fba500", fontColor: "#ffffff" });
                  flag = true;
                }
                if (activityStatus[a] == "F") {
                  colors.push({ id: a, color: "#67bc69", fontColor: "#ffffff" });
                  flag = true;
                }
                if (activityStatus[a] == "D") {
                  colors.push({ id: a, color: "#fb3500", fontColor: "#ffffff" });
                  flag = true;
                }
              }

              let activity = flowData.graph.activity;
              activity.map(v => {
                if (activityStatus[v.id] == null) {
                  if (v.type == "start") {
                    startId = v.id;
                  } else {
                    colors.push({
                      id: v.id,
                      color: "#999999",
                      fontColor: "#ffffff"
                    });
                  }
                }
              });
              if (flag) {
                colors.push({
                  id: startId,
                  color: "#67bc69",
                  fontColor: "#ffffff"
                });
              } else {
                colors.push({
                  id: startId,
                  color: "#999999",
                  fontColor: "#ffffff"
                });
              }
              me.color = colors;

              me.flowProcess = (await me.mwApi.process.getFlowProcess({
                batchId: me.params.batchId,
                readerAuthorize: false,
                requireReturnBusiness:true,
                sorts: [],
                type: 1
              })).result;

              if(me.flowProcess){
                _.each(me.flowProcess,function(n){
                  if(n.status=="被取回") {
                    n.status = "取回"
                  }else if(n.status=="被取消"  || (n.sourceMode=="发送" && n.status=="被强制终止")){
                    n.status = "被取回";
                  }
                  if(window.$Env && window.$Env.takenText && window.$Env.takenText !=""){
                    n.status = n.status.replace("取回",window.$Env.takenText)
                  }
                })
              }
              me.curFlowId = flowData.id;
              me.processList = flowData.pdList;
              me.processCount = me.processList.length;
              // me.show();
            }
          });
      },
      processSwitchClick() {
        var me = this;
        if (me.showProcessList) {
          me.showProcessList = false;
        } else {
          me.showProcessList = true;
        }
      },
      processClick(n, e) {
        var me = this;
        var params = {
          batchId: me.params.batchId,
          applicationId: me.params.applicationId,
          processDefinitionId: n.id
        };
        me.processChart(params);
      },
      /*show() {
        this.mwRef("dialog").show();
      },*/
      htmlEncode(str){
        if(!str)return "";
        return $('<div />').text(str).html()
      },
      handleRequestTitle(shape, resolver) {
        let me = this;
        const activityId = shape.id;
        const processNodes = (this.flowProcess || []).filter(
          x => x.activityId === activityId
        );

        const list = [
          {
            label: $lang("节点名称"),
            prop: "name"
          },
          {
            label: $lang("办理人"),
            prop: "assigneeName"
          },
          {
            label: $lang("办理部门"),
            prop: "department"
          },
          {
            label: $lang("签收时间"),
            prop: "claimTime"
          },
          {
            label: $lang("完成时间"),
            prop: "finishTime"
          },
          {
            label: $lang("状态"),
            prop: "status"
          },
          {
            label: $lang("意见"),
            prop: "comment"
          }
        ];
        if (processNodes.length > 0) {
          const preTaskMap={};
          this.flowProcess.forEach(n=>{
             preTaskMap[n.previousTaskId]=n;
          })
          processNodes.forEach(n => {
            if(preTaskMap[n.id] && preTaskMap[n.id].sourceMode
              && preTaskMap[n.id].sourceMode=="强制办毕(管理员干预)" && preTaskMap[n.id].businessField2) {
              const arry=preTaskMap[n.id].businessField2.split("_");
              const operator=arry.length==3? arry[2]:n.assigneeName;
              n.status = "强制办毕（" + operator + "）";
            }
            if (window.$currentBrowserLanguage === 'en') {
              n.assigneeName=n.assigneeEnglishname || n.candidateEnglishname || n.assigneeName; //还没有签收就取candidateEnglishname
              n.department=n.assigneeDeptEnglishname || n.department;
              n.name=$lang(n.name);
              n.status=$lang(n.status);
            }
          });

          resolver(wrapTable(
            processNodes.map((processNode, index) => {
              return `
                <tbody style="${index > 0 ? 'border-top:1px solid #fff;' : ''}">
                ${list.map(({ label, prop }) => {
                if (processNode[prop] == null) return "";
                return `<tr style="display:table-row">
                      <td style="padding: 10px 20px;text-align:right;white-space:nowrap;font-weight:normal;">${label}</td>
                      <td style="padding: 10px 20px;">`+me.htmlEncode(processNode[prop])+`</td>
                    </tr>`;
              }).join("")}
                </tbody>
              `;
            }).join("")
          ));
        }else{
          let activity=this.processDataGraph.activity.filter(a=>a.id===activityId);
          if(activity[0]){
            resolver(wrapTable(`
            <tbody>
              <tr style="display:table-row">
                <td style="padding: 10px 20px;text-align:right;white-space:nowrap;font-weight:normal;">${$lang("节点名称")}</td>
                <td style="padding: 10px 20px;">${$lang(activity[0].name)}</td>
              </tr>
            </tbody>
            `))
          }
        }
        function wrapTable(s){
          return `
          <table style="background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGMyfgoAAVQBGwzinUYAAAAASUVORK5CYII=);color:#fff;border-collapse:collapse">
            ${s}
          </table>
          `
        }
      }
    },
    watch: {
      params(newValue, oldValue) {
        this.processChart(newValue);
      }
    }
  };
</script>

<style lang="scss">
  .process-chart-viewer-dialog {
    & > .el-dialog > .el-dialog__body {
      padding-bottom: 0.5em;
    }
  }
  //流程图查看
  .mw-process-viewer {
    height: 100%;

    .process-list ._item {
      cursor: pointer;
    }
    .process-list .active {
      background-color: #bfe3fd;
    }

    .mw-process-chart {
      height: 100%;
      padding-right: 0px;
      position: relative;
    }

    .mw-process-chart-switch {
      ._toolbar {
        height: 40px;
        position: absolute;
        top: 51px;
        right: 205px;
        font-size: 14px;
        button {
          margin-top: 8px;
          margin-right: 10px;
          padding: 2px 5px;
          height: 22px;
        }
      }
      ._tab {
        position: absolute;
        top: 85px;
        right: 200px;
        width: 200px;
        height: 30px;
        z-index: 9999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/components/flow-chart-viewer.vue